import { Modal, Form } from "react-bootstrap"
import React, { useState } from "react";
import ReactLoading from "react-loading"
import warning from "../../../../Assets/Images/Modal/warning.png";
import "../../../../Components/Modals/Modal.css";

export default function SOModal(props) {
  const [reason, setReason] = useState("");
  const handleReason = (e) => {
    setReason(e.target.value)
  }
  const handleProceed = () => {
    props.onDelete(reason)
  }

  return (
    <div>
      <Modal show={props.show} onHide={props.hide} size="lg" centered>
        {/* <Modal.Header className="return-header">
          <span className="text-warning"> PLEASE CONFIRM </span>
        </Modal.Header> */}
        <Modal.Header closeButton />
        <Modal.Body>
        <div className="text">
            <h1> WARNING! </h1>
            <div className="text-wrapper">
              <div className="text-group delete-text">
                <h2>Are you sure you want to close this {props.text}?</h2>
                {/* <h3> The {props.text}’s details will be deleted immediately.</h3> */}
                <h3>You can’t undo this action. </h3>
              </div>
              <img
                src={warning}
                alt="warning"
                className="warning delete-warning"
              ></img>
            </div>
            <div className="mt-3">
              <span className="edit-label mb-2">
                Reason
                <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="textarea"
                name="remarks"
                className="nc-modal-custom-text"
                placeholder="Enter reason for voiding sales order.."
                onChange={handleReason}
                value={reason}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="return-footer">
          <button
            type="button"
            className={
              props.type === "disapprove"
                ? "button-warning"
                : "button-secondary"
            }
            onClick={props.hide}
          >
            Cancel
          </button>
          {props.isClicked === true && (
            <div className="button-primary d-flex justify-content-center">
              <ReactLoading
                type="bubbles"
                color="#FFFFFF"
                height={50}
                width={50}
              />
            </div>
          )}
          {/* {props.isClicked === false && (
            <button
              type="button"
              className={
                props.type === "disapprove"
                  ? "button-warning-fill"
                  : "button-primary"
              }
              onClick={props.handler}
            >
              Proceed
            </button>
          )} */}
         {props.isClicked === false && (
          <button
            className={
              props.type === "disapprove"
                ? "button-warning-fill"
                : "button-primary"
            }
            onClick={
              props.type === "disapprove"
                ? props.onDelete
                : handleProceed
            }
          >
            Proceed
          </button>
        )}
        </Modal.Footer>
      </Modal>
    </div>
  )
}